// ActionButtons.js
import { Button, createStyles, Group } from "@mantine/core";
import React from "react";

const useStyles = createStyles((theme) => ({
  saveBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    width: "50%",
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  cancelBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #D0D5DD",
    backgroundColor: "#F9FAFB",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#F9FAFB",
      opacity: 0.8,
    },
  },
}));

const SkypointActionButtons = ({ onCancel, type, activeTab, onSave, loading }) => {
  const { classes } = useStyles();
  return (
    <Group grow>
      <Button className={classes.cancelBtn} onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button className={classes.saveBtn} onClick={onSave} type={type} loading={loading}>
        {activeTab === "settings" ? "Save" : "Save and Next"}
      </Button>
    </Group>
  );
};

export default SkypointActionButtons;
